import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { getContentBlockItemsByName, getContentBlockItemByName } from '../../../Cms/CmsActions';

import FontCustom from '../../../../components/Content/FontCustom';
import CmsBlockItem from '../../../Cms/components/content/CmsBlockItem';


const PanelProductHighlight = ({ panel }) => {
    const title = getContentBlockItemByName(panel.blocks, 'title');
    const image = getContentBlockItemByName(panel.blocks, 'image');
    const imageStamp = getContentBlockItemByName(panel.blocks, 'image-stamp');
    const cta = getContentBlockItemByName(panel.blocks, 'call-to-action');

    return (
        <div className="mt-5 pt-1">
            <Container fluid className="mt-5 px-2 px-md-0 py-3 bg-warning">
                <Container className="position-relative py-5 text-center text-md-left">
                    <Row noGutters>
                        <Col xs={{ size: 12, order: 2 }} md={{ size: 7, order: 1 }}>
                            <div className="text-left pl-3 pl-md-0"><CmsBlockItem item={title} type="html" /></div>
                            {cta && cta.path && (
                                <Button color="light" size="lg" tag={Link} to={cta.path} className="mt-3">{cta.text}</Button>
                            )}
                        </Col>
                        <Col xs={{ size: 1, order: 2 }} className="d-none d-md-block">
                            {imageStamp && <CmsBlockItem item={imageStamp} type="image" className="position-absolute" style={{ bottom: '30px', right: 0 }} />}
                        </Col>
                        <Col xs={{ size: 12, order: 1 }} md={{ size: 4, order: 3 }} className="bg-custom-plant">
                            {image && <CmsBlockItem item={image} type="image" style={{ marginTop: '-150px', maxWidth: '280px' }} />}
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    );
};

PanelProductHighlight.propTypes = {
    panel: PropTypes.object.isRequired,
};

export default PanelProductHighlight;

export const PanelProductHighlightModel = {
    type: 'panel',
    name: 'productHighlight',
    blocks: [
        {
            name: 'title',
            type: 'html',
            max: 1,
        },
        {
            name: 'image',
            type: 'image',
            max: 1,
        },
        {
            name: 'image-stamp',
            type: 'image',
            max: 1,
        },
        {
            name: 'call-to-action',
            type: 'link',
        },
    ],
};
